/* Maju shipping protection v3 (2026-09-24): STORE-WIDE, ON BY DEFAULT, the customer can untick it.
   v1 9/18 store-wide auto-add; v2 9/18 drawer-only opt-in; v2.2 9/22 absolute quantity + resync; v3 9/24 (Rigney's ask) auto-add on every cart.
   Config from theme settings via window.MAJU_SP (layout/theme.liquid): { on, variantId, price, handles, defaultOn }
     handles = comma list of product handles the auto-add applies to, blank = every product; defaultOn = add automatically.
   Rules: one unit per order, written with /cart/update and an ABSOLUTE quantity (never doubled, even from a stale page);
   the line leaves the cart only when nothing else is left in it; an untick is remembered in localStorage (maju_sp_off) and
   stops the auto-add in that browser until the customer ticks it again; landers ask MAJU_SP.want() and send the line inside
   their own add request. Only the drawer FOOTER and the cart page sections are repainted, so scripts that own the drawer
   line items (the OTP upgrade card) are never disturbed. The footer is re-read after a back/forward-cache restore or tab focus. */
(function () {
  var C = window.MAJU_SP = window.MAJU_SP || {};
  var OPT = 'maju_sp_off';
  var own = false;
  function num(v) { v = parseInt(v, 10); return isNaN(v) ? 0 : v; }
  function route(k, fb) { return (window.routes && window.routes[k]) || fb; }
  C.optedOut = function () { try { return localStorage.getItem(OPT) === '1'; } catch (e) { return false; } };
  C.setOptOut = function (v) { try { if (v) localStorage.setItem(OPT, '1'); else localStorage.removeItem(OPT); } catch (e) {} };
  C.active = function () { return !!(C.on && num(C.variantId)); };
  C.autoOn = function () { return C.active() && C.defaultOn !== false && !C.optedOut() && !window.MAJU_SP_NOAUTO; }; // MAJU_SP_NOAUTO: set by the landers (no protection line from a lander, the checkout offer covers it)
  // Landers: should the straight-to-checkout add carry the protection line?
  C.want = function () {
    if (!C.active() || C.optedOut()) return false;
    var t = document.getElementById('spCheck');
    return t ? t.checked : C.defaultOn !== false;
  };
  function post(url, body) {
    own = true;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .finally(function () { own = false; });
  }
  function getCart() {
    return fetch(route('cart_url', '/cart') + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function isSP(i) { return num(i.variant_id) === num(C.variantId); }
  function handles() { return String(C.handles || '').split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(Boolean); }
  function eligible(i) { var h = handles(); return h.length === 0 || h.indexOf(String(i.handle || '').toLowerCase()) !== -1; }
  function pageEl(id) { return document.getElementById(id); }
  // Sections re-rendered with every cart write: the drawer, plus the cart page sections when the customer is on /cart.
  function sections() {
    var s = ['cart-drawer', 'cart-icon-bubble'], i = pageEl('main-cart-items'), f = pageEl('main-cart-footer');
    if (i && i.dataset.id) s.push(i.dataset.id);
    if (f && f.dataset.id) s.push(f.dataset.id);
    return s.join(',');
  }
  // Repaint the drawer the way the theme does (items + footer): every protection write shifts the cart line numbers
  // that the theme's remove and quantity buttons carry (new lines land at position 1), so the rows must be re-rendered.
  function paintFooter(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
      var t = document.querySelector('cart-drawer ' + sel), s = doc.querySelector(sel);
      if (t && s) t.replaceWith(s);
    });
  }
  function paintCartPage(r) {
    var ok = false;
    [pageEl('main-cart-items'), pageEl('main-cart-footer')].forEach(function (el) {
      if (!el || !el.dataset.id || !r.sections[el.dataset.id]) return;
      var doc = new DOMParser().parseFromString(r.sections[el.dataset.id], 'text/html');
      var t = el.querySelector('.js-contents'), s = doc.querySelector('.js-contents');
      if (t && s) { t.innerHTML = s.innerHTML; ok = true; }
    });
    return ok;
  }
  function paintBubble(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var t = document.getElementById('cart-icon-bubble'), s = doc.querySelector('.shopify-section');
    if (t && s) t.innerHTML = s.innerHTML;
  }
  // The theme renders an empty drawer without a footer: on the empty transition swap the whole drawer inner, the way the theme does.
  function paintDrawerInner(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var d = document.querySelector('cart-drawer'), nd = doc.querySelector('cart-drawer');
    if (!d || !nd) return;
    var t = d.querySelector('.drawer__inner'), s = nd.querySelector('.drawer__inner');
    if (t && s) t.replaceWith(s);
  }
  function syncEmpty(r) {
    if (typeof r.item_count !== 'number') return;
    var empty = r.item_count === 0;
    ['cart-items', '#main-cart-footer', 'cart-drawer'].forEach(function (sel) { var el = document.querySelector(sel); if (el) el.classList.toggle('is-empty', empty); });
  }
  function painted(r) {
    if (!r || !r.sections) return false;
    var ok = false;
    if (r.sections['cart-drawer']) { if (r.item_count === 0) paintDrawerInner(r.sections['cart-drawer']); else paintFooter(r.sections['cart-drawer']); ok = true; }
    paintBubble(r.sections['cart-icon-bubble']);
    if (paintCartPage(r)) ok = true;
    syncEmpty(r);
    return ok;
  }
  function footerFromCart() {
    return fetch(route('cart_url', '/cart') + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(paintFooter).catch(function () {});
  }
  function refresh(r) { if (!painted(r)) return footerFromCart(); }
  function setBusy(on) { document.querySelectorAll('.js-sp-cart-check').forEach(function (t) { t.disabled = !!on; }); }
  function setChecked(v) { document.querySelectorAll('.js-sp-cart-check').forEach(function (t) { t.checked = !!v; }); }
  // Instant feedback: move the displayed subtotal by the protection price before the server answers.
  function bumpTotal(sign) {
    var p = parseFloat(String(C.price || '').replace(/[^0-9.]/g, '')) || 0;
    document.querySelectorAll('cart-drawer .totals__total-value, #main-cart-footer .totals__total-value').forEach(function (el) {
      var m = el.textContent.match(/(\d[\d,]*)(?:\.(\d{2}))?/);
      if (!m) return;
      var cur = parseFloat(m[1].replace(/,/g, '')) + (m[2] ? parseInt(m[2], 10) / 100 : 0);
      var next = Math.max(0, cur + sign * p).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      el.textContent = el.textContent.replace(m[0], next);
    });
  }
  function setOne() {
    // /cart/update sets an ABSOLUTE quantity by variant id and adds the line when it is absent: one unit, even from a stale page.
    var upd = {}; upd[String(num(C.variantId))] = 1;
    return post(route('cart_update_url', '/cart/update') + '.js', { updates: upd, sections: sections() });
  }
  function dropLine(key) { return post(route('cart_change_url', '/cart/change') + '.js', { id: key, quantity: 0, sections: sections() }); }
  C.add = function () {
    if (!C.active()) return Promise.resolve();
    setBusy(true); setChecked(true); bumpTotal(1);
    return setOne().then(refresh).catch(function () { return footerFromCart(); }).finally(function () { setBusy(false); });
  };
  C.remove = function () {
    if (!C.active()) return Promise.resolve();
    setBusy(true); setChecked(false); bumpTotal(-1);
    // /cart/change accepts the variant id (as a string) in place of the line key: one round trip.
    return dropLine(String(num(C.variantId)))
      .then(function (r) {
        if (painted(r)) return;
        return getCart().then(function (c) {
          var sp = (c.items || []).filter(isSP)[0];
          if (!sp) return footerFromCart();
          return dropLine(sp.key).then(refresh);
        });
      })
      .catch(function () { return footerFromCart(); }).finally(function () { setBusy(false); });
  };
  // The guard, after any cart change: add the line when the cart holds an eligible product and the customer has not opted out,
  // keep it at one unit, and drop it when it would be the only line left.
  var busy = null;
  C.ensure = function () {
    if (!C.active()) return Promise.resolve();
    if (busy) return busy;
    busy = getCart().then(function (c) {
      var sp = null, others = 0, elig = 0;
      (c.items || []).forEach(function (i) { if (isSP(i)) sp = i; else { others += i.quantity; if (eligible(i)) elig += i.quantity; } });
      if (sp && others === 0) {
        // grace period: another script may be swapping lines (remove, then add); confirm the cart is really empty otherwise
        return new Promise(function (res) { setTimeout(res, 1500); }).then(getCart).then(function (c2) {
          var sp2 = null, o2 = 0;
          (c2.items || []).forEach(function (i) { if (isSP(i)) sp2 = i; else o2 += i.quantity; });
          if (sp2 && o2 === 0) return dropLine(sp2.key).then(refresh);
        });
      }
      if (sp && sp.quantity > 1) return post(route('cart_change_url', '/cart/change') + '.js', { id: sp.key, quantity: 1, sections: sections() }).then(refresh);
      if (!sp && elig > 0 && C.autoOn()) { setChecked(true); bumpTotal(1); return setOne().then(refresh); }
    }).catch(function () {}).finally(function () { busy = null; });
    return busy;
  };
  C.prune = C.ensure;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('js-sp-cart-check')) {
      if (t.checked) { C.setOptOut(false); C.add(); } else { C.setOptOut(true); C.remove(); }
    } else if (t.id === 'spCheck') {
      C.setOptOut(!t.checked);
    }
  });
  function hookEvents() {
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(C.ensure, 120); });
    }
  }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(C.ensure, 120); }, function () {});
    }
    return p;
  };
  // A page restored from the back/forward cache, or a tab shown again, may hold a stale drawer: re-read the footer and re-check the cart.
  function resync() { if (!C.active()) return; if (document.querySelector('cart-drawer')) footerFromCart(); C.ensure(); }
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) resync(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') resync(); });
  function start() { hookEvents(); C.ensure(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
